/** @jsxImportSource react */
import FunctionsIcon from '@mui/icons-material/Functions'
import ShortTextIcon from '@mui/icons-material/ShortText'
import NotesIcon from '@mui/icons-material/Notes'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined'
import LinkIcon from '@mui/icons-material/Link'
import NumbersIcon from '@mui/icons-material/Numbers'
import PercentIcon from '@mui/icons-material/Percent'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import ScheduleIcon from '@mui/icons-material/Schedule'
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined'
import ArrowDropDownCircleOutlinedIcon from '@mui/icons-material/ArrowDropDownCircleOutlined'
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'
import ChecklistIcon from '@mui/icons-material/Checklist'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

const ICONS = {
  TEXT: ShortTextIcon,
  TEXTAREA: NotesIcon,
  EMAIL: AlternateEmailIcon,
  PHONE: PhoneOutlinedIcon,
  URL: LinkIcon,
  NUMBER: NumbersIcon,
  DECIMAL: PercentIcon,
  CURRENCY: PaymentsOutlinedIcon,
  DATE: CalendarTodayOutlinedIcon,
  DATETIME: ScheduleIcon,
  CHECKBOX: CheckBoxOutlinedIcon,
  SELECT: ArrowDropDownCircleOutlinedIcon,
  RADIO: RadioButtonCheckedIcon,
  MULTI_SELECT: ChecklistIcon,
  LOOKUP: AccountTreeOutlinedIcon,
  USER: PersonOutlineIcon,
  ROLLUP: FunctionsIcon,
}

const FieldTypeIcon = ({ type, ...props }) => {
  const Icon = ICONS[type] || ShortTextIcon
  return <Icon fontSize="small" {...props} />
}

export default FieldTypeIcon
